<template>
  <div class="is-flex align-center">
    <div class="is-flex flex-column ml-1">
      <span class="has-text-weight-bold">{{ checklist.name }}</span>
    </div>
  </div>
</template>

<script>
export default {

  props: {
    checklist: {
      type: Object,
      required: true,
    },
  }

}
</script>
